import journal from "./journal";
import news from "./news";
import workbench from "./workbench";
import special from "./special";
import editor from "./editor";
import page from "./page";

const Routers = [journal, news, workbench, special, editor, page];

export default Routers;
